import * as types from './constants';

export const initialState = {
  dataTable: [],
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  status: null,
  invoiceStatus: null,
  searchQ: '',
  dateAfter: null,
  dateBefore: null,
  errors_api: {}
};

const actions = {
  [types.GET_NETWORK_ORDERS_REQUEST]: state => ({
    ...state,
    loading: true
  }),

  [types.GET_NETWORK_ORDERS_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    ...payload
  }),

  [types.GET_NETWORK_ORDERS_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.SET_NETWORK_ORDERS_STATUS_FILTER]: (state, { payload }) => ({
    ...state,
    status: payload.status,
    invoiceStatus: payload.invoiceStatus,
    curr_page: 1
  }),

  [types.SET_NETWORK_ORDERS_SEARCH_FILTER]: (state, { payload }) => ({
    ...state,
    searchQ: payload,
    curr_page: 1
  }),

  [types.SET_NETWORK_ORDERS_DATE_RANGE_FILTER]: (state, { payload }) => ({
    ...state,
    dateAfter: payload.dateAfter,
    dateBefore: payload.dateBefore,
    curr_page: 1
  }),

  [types.NETWORK_ORDERS_SET_PAGE]: (state, { payload }) => ({
    ...state,
    curr_page: parseInt(payload) || 1
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
